import {makeAutoObservable, runInAction} from 'mobx';
import {ITeam} from '../types';
import {
    createTeam,
    delTeam,
    editTeam,
    fetchInviteLink,
    fetchMyTeam,
    fetchTeam,
    fetchTeams,
    joinTeam,
    leaveTeam,
    searchTeams
} from '@/shared/api/api';
import {RootStore} from "@/app/providers/StoreProvider";


export class TeamStore {

    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    get errorStore() {
        return this.rootStore.errorStore;
    }

    myTeam: ITeam | null = null;
    myTeamLoaded: boolean = false;
    team: ITeam | null = null;
    searchTeams: ITeam[] = [];
    search = '';
    link = '';

    loadingTeams = false;
    loadingSearchTeams = false;


    getMyTeam = async () => {
        this.loadingTeams = true;
        try {
            const myTeam = await fetchMyTeam();
            if (myTeam.success) {
                runInAction(() => {
                    if(myTeam.data){
                        this.myTeam = myTeam.data;
                    }
                    this.myTeamLoaded = true;
                });
            } else {
                this.myTeam = null;
                this.errorStore.setError(myTeam.error)
            }
        } finally {
            runInAction(() => {
                this.loadingTeams = false;
            });
        }
    }
    getTeam = async (id: string) => {
        this.loadingTeams = true;
        try {
            const team = await fetchTeam(id);
            if (team.success) {
                runInAction(() => {
                    this.team = team.data;
                });
            } else {
                this.errorStore.setError(team.error)
            }
        } finally {
            runInAction(() => {
                this.loadingTeams = false;
            });
        }

    }

    getInviteLink = async () => {
        try {
            const link = await fetchInviteLink();
            if (link.success) {
                runInAction(() => {
                    this.link = link.data;
                });
            } else {
                this.errorStore.setError(link.error)
            }
        } finally {
        }
    }

    getSearchTeams = async (name: string) => {
        this.loadingSearchTeams = true;
        try {
            const teams = await searchTeams(name);
            if (teams.success) {
                runInAction(() => {
                    this.searchTeams = teams.data;
                    this.search = name;
                });
            } else {
                this.errorStore.setError(teams.error)
            }
        } finally {
            runInAction(() => {
                this.loadingSearchTeams = false;
            });
        }
    }
    clearSearchTeams = () => {
        this.search = '';
        this.searchTeams = [];
    }


    createTeam = async (name: string, file: FormData) => {
        this.loadingTeams = true;
        try {
            const team = await createTeam(name, file);
            if (team.success) {
                return true;
            } else {
                this.errorStore.setError(team.error)
            }
        } finally {
            runInAction(() => {
                this.loadingTeams = false;
            });
        }
    }
    editTeam = async (name?: string, file?: FormData) => {
        this.loadingTeams = true;
        try {
            const team = await editTeam(name, file);
            if (team.success) {
                return true
            } else {
                this.errorStore.setError(team.error)
            }
        } finally {
            runInAction(() => {
                this.loadingTeams = false;
            });
        }
    }

    deleteTeam = async () => {
        try {
            const teams = await delTeam();
            if (teams.success) {
                this.myTeam = null;
                this.team = null;
            } else {
                this.errorStore.setError(teams.error)
            }
        } finally {
        }
    }

    joinTeam = async (inviteCode: string) => {
        this.loadingSearchTeams = true;
        try {
            const team = await joinTeam(inviteCode);
            if (team.success) {
                runInAction(() => {
                    this.myTeam = team.data;
                    this.team = team.data;
                });
            } else {
                this.errorStore.setError(team.error)
            }
        } finally {
            runInAction(() => {
                this.loadingSearchTeams = false;
            });
        }
    }

    leaveTeam = async (userId: number | null) => {
        this.loadingSearchTeams = true;
        try {
            const team = await leaveTeam(userId);
            if (team.success) {
                if (userId == null) {
                    runInAction(() => {
                        this.myTeam = null;
                        this.team = null;
                    });
                }
                if (this.myTeam)
                    this.getTeam(this.myTeam.id);
            } else {
                this.errorStore.setError(team.error)
            }
        } finally {
            runInAction(() => {
                this.loadingSearchTeams = false;
            });
        }
    }

}



